
import { defineComponent, Ref, ref } from 'vue';
import {
    listPagination, RequestData, ListActionItem, getSearch
} from '@/components/common/list';
import { payProcessing, cancel } from '@/components/view/common/payment';
import router from '@/router';
import { installerBaseRouter, installerSubRouter } from '@/router/data';
import noticeBase from '@/util/notice.base';
import { initData } from './util';

export default defineComponent({
    components: {
        listPagination,
        payProcessing
    },
    setup() {
        const {
            headers,
            typeOptions,
            statusOptions
        } = initData();
        const updateToList = ref(0);
        const listRequestData: Ref<RequestData> = ref({
            url: 'v3/web/single/order/getList',
            param: getSearch({
                ProjectType: 'single',
                Type: 'all',
                Status: 'all',
                Key: ''
            })
        });
        const isShowPayprocessing = ref(false);
        const payJumpUrl = ref('');
        const action: ListActionItem[] = [{
            type: 'pay',
            event(val: { bmurl: string }) {
                isShowPayprocessing.value = true;
                payJumpUrl.value = val.bmurl;
                window.open(val.bmurl);
            },
            class: 'el-icon-my-pay modify-icon',
            showCondition(val: { StatusEnum: string }) {
                return val.StatusEnum === '0';
            },
            title: WordList.OrderPay
        },
        {
            type: 'cancelpay',
            event(val: { OrderNumber: string; BmOrderNumber: string; PayCode: string }) {
                noticeBase.messageBox('confirm', WordList.TabelPaymentCancel, WordList.TabelDeleteTitle, 'warning')(() => {
                    cancel.cancelOrder({ OrderNumber: val.OrderNumber }, () => {
                        updateToList.value += 1;
                    });
                });
            },
            class: 'el-icon-my-cancel-payment cancelpay-icon',
            showCondition(val: { StatusEnum: string }) {
                return val.StatusEnum === '0';
            },
            title: WordList.TabelFootCancel
        }];
        const successPay = () => {
            isShowPayprocessing.value = false;
            updateToList.value += 1;
        };
        const goInfo = (value: { ID: string }) => {
            router.push(`/${installerBaseRouter}/${installerSubRouter.paymentinfo}?id=${value.ID}`);
        };
        return {
            headers,
            updateToList,
            listRequestData,
            typeOptions,
            statusOptions,
            action,
            isShowPayprocessing,
            successPay,
            goInfo,
            getSearch,
            payJumpUrl
        };
    }
});
